export default {
  BT_HDP: "Handicap | HDP",
  BT_OU: "Besar/Kecil | O/U",
  BT_ML: "Moneyline",
  BT_1X2: "1X2",
  BT_1X2HDP: "Handicap 3 arah",
  BT_CS: "Skor Yang Tepat",
  BT_OE: "Ganjil/Genap | Ganjil/Genap",
  BT_DC: "Peluang Ganda",
  BT_HTFT: "Babak Pertama/Waktu Penuh",
  BT_FGLG: "Gol Pertama/Gol Terakhir",
  BT_TG: "Total Gol",
  BT_OR: "Outright",
  BT_ORZ: "Outright",

  BT_ANB: "Away No Bet",
  BT_BS: "Keduanya/Salah Satu/Tidak Satu Pun mencetak skor",
  BT_CL: "Catatan Bersih",
  BT_DNB: "Taruhan Tanpa Seri",
  BT_DNBH: "HT. Taruhan Tanpa Seri",
  BT_HNB: "Home No Bet",
  BT_TWTN: "Menang Tanpa Kebobolan Gol",

  BT_HDPF: "FT. Handicap | FT. HDP",
  BT_OUF: "FT. Besar/Kecil | FT. O/U",
  BT_MLF: "FT. Moneyline | FT. ML",
  BT_1X2F: "FT. 1X2",
  BT_1X2HDPF: "FT. Handicap 3 arah",
  BT_CSF: "FT. Skor Yang Tepat",
  BT_OEF: "FT. Ganjil/Genap | FT. O/E",
  BT_DCF: "FT. Peluang Ganda",
  BT_FGLGF: "FT. Gol Pertama/Gol Terakhir",
  BT_TGF: "FT. Total Gol",

  BT_HDPH: "HT. Handicap | HT. HDP",
  BT_OUH: "HT. Besar/Kecil | HT. O/U",
  BT_MLH: "HT. Moneyline | HT. ML",
  BT_1X2H: "HT. 1X2",
  BT_1X2HDPH: "HT. Handicap 3 arah",
  BT_CSH: "HT. Skor Yang Tepat",
  BT_OEH: "HT. Ganjil/Genap",
  BT_DCH: "HT. Peluang Ganda",
  BT_FGLGH: "HT. Gol Pertama/Gol Terakhir",
  BT_TGH: "HT. Total Gol",
  BT_O: "Besar",
  BT_U: "Kecil",
  BT_ODD: "Ganjil",
  BT_EVEN: "Genap",

  BT_HDPOU: "HDP & OU",
  BT_PARLAY: "Taruhan Campuran",
  BT_FT: "Waktu Penuh",
  BT_1H: "Babak Pertama",
  BT_2H: "Babak Kedua",

  BT_FG: "Gol Pertama",
  BT_LG: "Gol Terakhir",
  BT_HFG: "Tim Kandang Gol Pertama",
  BT_AFG: "Tim Tandang Gol Pertama",
  BT_HLG: "Tim Kandang Gol Terakhir",
  BT_ALG: "Tim Tandang Gol Terakhir",
  BT_NG: "Tidak Ada Gol",
  BT_HY: "Tim Kandang Ya",
  BT_HN: "Tim Kandang Tidak",
  BT_AY: "Tim Tandang Ya",
  BT_AN: "Tim Tandang Tidak",
  BT_H: "Tim Kandang",
  BT_A: "Tim Tandang",
  BT_D: "Seri",
  BT_HD_DC: "Tim Kandang atau Seri",
  BT_HA_DC: "Tim Kandang atau Tim Tandang",
  BT_DA_DC: "Tim Tandang atau Seri",
  BT_HH: "Tim Kandang/Tim Kandang",
  BT_HD: "Tim Kandang/Seri",
  BT_HA: "Tim Kandang/Tim Tandang",
  BT_DH: "Seri/Tim Kandang",
  BT_DD: "Seri/Seri",
  BT_DA: "Seri/Tim Tandang",
  BT_AH: "Tim Tandang/Tim Kandang",
  BT_AD: "Tim Tandang/Seri",
  BT_AA: "Tim Tandang/Tim Tandang",

  BT_Y: "Ya",
  BT_N: "Tidak",

  BT_LIVE: "LANGSUNG",
  BT_HT: "H.Time",
  BT_DELAYED: "Menunda",
  BT_PEN: "PEN",

  BT_FT1: "FT.1",
  BT_FT2: "FT.2",
  BT_FTX: "FT.X",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "Keduanya",
  BT_ONE: "Satu",

  BS_HDP: "FT Handicap",
  BS_HDPH: "HT. Handicap",
  BS_OU: "FT. Besar/Kecil",
  BS_OUH: "HT. Besar/Kecil",
  BS_OE: "FT. Ganjil/Genap",
  BS_OEH: "HT. Ganjil/Genap",
  BS_1X2: "FT. 1X2",
  BS_1X2H: "HT. 1X2",
  BS_ML: "FT Moneyline",
  BS_MLH: "HT. Moneyline",
  BS_1X2HDP: "FT. Handicap 3 arah",
  BS_1X2HDPH: "HT. Handicap 3 arah",
  BS_CS: "FT. Skor Yang Tepat",
  BS_CSH: "HT. Skor Yang Tepat",
  BS_DC: "FT. Peluang Ganda",
  BS_DCH: "HT. Peluang Ganda",
  BS_FGLG: "FT. Gol Pertama/Gol Terakhir",
  BS_FGLGH: "HT. Gol Pertama/Gol Terakhir",
  BS_TG: "FT. Total Gol",
  BS_TGH: "HT. Total Gol",
  BS_ANB: "Away No Bet",
  BS_HTFT: "Babak Pertama/Waktu Penuh",
  BS_BS: "Keduanya/Salah Satu/Tidak Satu Pun mencetak skor",
  BS_CL: "Catatan Bersih",
  BS_DNB: "Taruhan Tanpa Seri",
  BS_DNBH: "HT. Taruhan Tanpa Seri",
  BS_HNB: "Home No Bet",
  BS_TWTN: "Menang Tanpa Kebobolan Gol",
  BS_OR: "Outright",
  BS_ORZ: "Outright",
  
  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "All Bet Type",

  _1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "K.O. By",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "BESAR (4,5,6)",
  GH_UNDER: "KECIL (1,2,3)",
  GH_ODD: "GANJIL (1,3,5)",
  GH_EVEN: "GENAP (2,4,6)",
  GH_OU1: "BESAR (4,5,6)",
  GH_OU2: "KECIL (1,2,3)",
  GH_OE1: "GANJIL (1,3,5)",
  GH_OE2: "GENAP (2,4,6)",

  GX_1X2: "WIN",
  GX_1X20: "WIN",
  GX_1X2HDP: "PLACE/SHOW",
  GX_1X2HDP2: "PLACE",
  GX_1X2HDP4: "SHOW",
  GX_OVER: "BESAR (7-12)",
  GX_UNDER: "KECIL (1-6)",
  GX_ODD: "GANJIL (1,3,5,7,9,11)",
  GX_EVEN: "GENAP (2,4,6,8,10,12)",
  GX_OU1: "BESAR (7-12)",
  GX_OU2: "KECIL (1-6)",
  GX_OE1: "GANJIL (1,3,5,7,9,11)",
  GX_OE2: "GENAP (2,4,6,8,10,12)",

  GC_OU: "O/U",
  GC_OE: "O/E",
  GC_OVER: "BESAR (3,4,5)",
  GC_UNDER: "KECIL (0,1,2)",
  GC_ODD: "GANJIL (1,3,5)",
  GC_EVEN: "GENAP (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "BOLA PERTAMA",
  GC_1X20: "UNTUK MENANG",
  GC_ML: "BOLA PERTAMA",
  GC_1X2: "UNTUK MENANG",
  GC_OU1: "BESAR (3,4,5)",
  GC_OU2: "KECIL (0,1,2)",
  GC_OE1: "GANJIL (1,3,5)",
  GC_OE2: "GENAP (0,2,4)",

  ROOM_A: "Terbuka",
  ROOM_0: "Aktif",
  ROOM_1: "Tutup",
  ROOM_2: "Batal",
  ROOM_3: "Berakhir",
  ROOM_4: "Berhenti Bertaruh",
  ROOM_10: "Semua",

  ROOM_T0: "Semua",
  ROOM_T1: "Ruang Publik",
  ROOM_T2: "Ruang Privat",
  ROOM_T3: "Main untuk Mendapatkan",

  joinRoom1: "Gabung Ruang Publik",
  joinRoom2: "Gabung Ruang Privat",
  joinRoom3: "Gabung Ruang Permainan",
  createRoom1: "Buat Ruang Publik",
  createRoom2: "Buat Ruang Privat",
  createRoom3: "Buat Ruang Permainan",
  Champion: "Juara",
  FirstRunnerUp: "Juara Kedua",
  SecondRunnerUp: "Juara Ketiga",

  BT_OEHM: "Ganjil/Genap Kandang | Kandang G/G",
  BT_OEHMH: "FH. Ganjil/Genap Kandang | FH. Kandang G/G",
  BT_OEAW: "Ganjil/Genap Tandang | Tandang G/G",
  BT_OEAWH: "FH. Ganjil/Genap Tandang | FH. Tandang G/G",

  BS_OEHM: "FT. Ganjil/Genap Kandang | FT. Kandang G/G",
  BS_OEHMH: "FH. Ganjil/Genap Kandang | FH. Kandang G/G",
  BS_OEAW: "FT. Ganjil/Genap Tandang | FT. Tandang G/G",
  BS_OEAWH: "FH. Ganjil/Genap Tandang | FH. Tandang G/G",

  MB_OVER: "BESAR (4,5,6)",
  MB_UNDER: "KECIL (1,2,3)",
  MB_ODD: "GANJIL (1,3,5)",
  MB_EVEN: "GENAP (2,4,6)",

  BS_1X2OU: "1X2 + B/K",
  BT_1X2OU: "1X2 + B/K",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Peluang Ganda + O/U",
  BT_DCOU: "Peluang Ganda + O/U",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "B/K + G/G",
  BT_OUOE: "B/K+ G/G",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + G/G",
  BT_HTFTOE: "HT/FT + G/G",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "Margin Kemenangan",
  BT_WM: "Margin Kemenangan",
  BK_H1: "Kandang 1",
  BK_H2: "Kandang 2",
  BK_H3Up: "Kandang 3+",
  BK_A1: "Tandang 1",
  BK_A2: "Tandang 2",
  BK_A3Up: "Tandang 3+",
  BK_D: "Seri Skor (Kecuali 0-0)",
  BK_NG: "Tanpa Gol",

  BS_ETG: "Jumlah Gol Tepat",
  BT_ETG: "Jumlah Gol Tepat",
  BS_EHTG: "Jumlah Gol Kandang Tepat",
  BT_EHTG: "Jumlah Gol Kandang Tepat",
  BS_EATG: "Jumlah Gol Tandang Tepat",
  BT_EATG: "Jumlah Gol Tandang Tepat",
  BS_ETGH: "BB. Jumlah Gol Tepat",
  BT_ETGH: "BB. Jumlah Gol Tepat",
  BS_EHTGH: "BB. Gol Kandang Tepat",
  BT_EHTGH: "BB. Gol Kandang Tepat",
  BS_EATGH: "BB. Gol Tandang Tepat",
  BT_EATGH: "BB. Gol Tandang Tepat",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "Skor HT/FT",
  BS_CSHTFT: "Skor HT/FT",
  BT_ETGHTFT: "Total Gol HT/FT",
  BS_ETGHTFT: "Total Gol HT/FT",
};